module.exports = __webpack_public_path__ + "static/MacBook Pro-d7cccdde64dc2f53d52e48319c7a0c7f.png";